import React, { useEffect, useRef, useState } from 'react';
import { ArrowUp } from 'lucide-react';

// Floating button shown once the top (next-task) anchor scrolls out of view, so
// staff can jump back to the task after reading older timeline history.
export const BackToTaskButton = ({ targetId }) => {
  const [show, setShow] = useState(false);
  const observer = useRef(null);

  useEffect(() => {
    const el = document.getElementById(targetId);
    if (!el || !('IntersectionObserver' in window)) return;
    observer.current = new IntersectionObserver(
      ([entry]) => setShow(!entry.isIntersecting),
      { threshold: 0 }
    );
    observer.current.observe(el);
    return () => observer.current?.disconnect();
  }, [targetId]);

  if (!show) return null;
  return (
    <button
      type="button"
      onClick={() => document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
      className="fixed bottom-20 right-4 z-40 flex items-center gap-1.5 rounded-full bg-[#0DA891] px-4 py-2.5 text-sm font-semibold text-white shadow-lg transition-transform hover:scale-105 active:scale-95"
      aria-label="Back to task"
      data-testid="back-to-task-button"
    >
      <ArrowUp className="h-4 w-4" />Back to task
    </button>
  );
};
